import FreeLoaclMoveDefault from './FreeLocalMoveDefault'

const FreeLocalMove = ({ close = () => {} }) => {
    return <FreeLoaclMoveDefault close={close} />
}

export default FreeLocalMove
